<template>
  <div class="relative">
    <b-table
      :items="items"
      :fields="fieldsCutOfTime"
      show-empty
      responsive
      sticky-header
      :empty-text="isLoading ? '' : 'Tidak ada data untuk ditampilkan.'"
    >
      <template #cell(id)="row">
        <div class="flex items-center gap-[8px]">
          <button
            class="flex items-center justify-center  p-[2px] text-primary rounded-full transition-all duration-300"
            :class="{
              'hover:!bg-[#08A0F7]/10': onEditMode,
              'hover:!bg-[#828282]/10': !onEditMode,
            }"
            :disabled="!onEditMode"
            @click="handleEdit(row.item)"
          >
            <span
              class="k-edit text-[20px]"
              :class="{
                'text-[#08A0F7]': onEditMode,
                'text-[#828282]': !onEditMode,
              }"
            />
          </button>
          <button
            class="flex items-center justify-center  p-[2px] text-danger rounded-full transition-all duration-300"
            :class="{
              'hover:!bg-[#F95031]/10': onEditMode,
              'hover:!bg-[#828282]/10': !onEditMode,
            }"
            :disabled="!onEditMode"
            @click="handleDelete(row.item)"
          >
            <span
              class="k-trash text-[20px]"
              :class="{
                'text-[#F95031]': onEditMode,
                'text-[#828282]': !onEditMode,
              }"
            />
          </button>
        </div>
      </template>
    </b-table>
    <div
      v-if="isLoading"
      class="absolute bottom-0 left-0 right-0 flex justify-center items-center p-[20px] bg-white bg-opacity-90"
    >
      <div class="flex items-center gap-2">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        <span class="text-sm text-gray-600">Memuat data...</span>
      </div>
    </div>
  </div>
</template>

<script>
import { toastError } from '@/libs/toastification'
import { fieldsCutOfTime } from '../config'

/**
 * COTTable
 * @description COTTable is a component that displays the cut off time of the warehouse
 * @param {Number} warehouseId - The warehouse id
 * @param {Boolean} onEditMode - The on edit mode
 * @returns {Object} COTTable
 */
export default {
  name: 'COTTable',
  props: {
    warehouseId: {
      type: Number,
      required: true,
    },
    onEditMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      isLoading: false,
      fieldsCutOfTime,
    }
  },
  watch: {
    warehouseId: {
      handler(newVal) {
        if (newVal >= 0) {
          this.refetchData()
        }
      },
    },
  },
  mounted() {
    if (this.warehouseId >= 0) {
      this.refetchData()
    }
  },
  methods: {
    fetchCutOffTime() {
      this.isLoading = true
      this.$http_new.get(`/komship/api/v1/warehouse-operational-times/cut-of-time/${this.warehouseId}`).then(res => {
        const { data } = res.data
        this.items = data
      }).catch(() => {
        toastError('Gagal mengambil data cut off time, silahkan refresh untuk coba lagi')
      }).finally(() => {
        this.isLoading = false
      })
    },
    /**
     * Refetch the data, this function would be called by the parent component
     */
    refetchData() {
      this.fetchCutOffTime()
    },
    handleEdit(item) {
      this.$emit('request-edit', item)
    },
    handleDelete(item) {
      this.$emit('request-delete', item)
    },
  },
}
</script>
